var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBatteryOnlyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33594 11.6667H5.33594C4.23137 11.6667 3.33594 12.5621 3.33594 13.6667V31.3333C3.33594 32.4379 4.23137 33.3333 5.33594 33.3333H34.6693C35.7738 33.3333 36.6693 32.4379 36.6693 31.3333V13.6667C36.6693 12.5621 35.7738 11.6667 34.6693 11.6667H31.6693M8.33594 11.6667V8.5C8.33594 7.94772 8.78365 7.5 9.33594 7.5H12.3359C12.8882 7.5 13.3359 7.94772 13.3359 8.5V11.6667M8.33594 11.6667H13.3359M13.3359 11.6667H26.6693M26.6693 11.6667V8.5C26.6693 7.94772 27.117 7.5 27.6693 7.5H30.6693C31.2216 7.5 31.6693 7.94772 31.6693 8.5V11.6667M26.6693 11.6667H31.6693",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8359 16.667V21.667M8.33594 19.167H13.3359M26.6693 19.167H31.6693",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBatteryOnlyWhite);
export default __webpack_public_path__ + "static/media/icon-battery-only-white.f9a5a5618eb84d7bfee2208218330aa1.svg";
export { ForwardRef as ReactComponent };